<template>
  <el-dialog
    title="渠道变更"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <div style="padding: 20px 0; text-align: center;">
      <el-select
        v-model="channelName"
        filterable
        remote
        reserve-keyword
        placeholder="请输入关键字搜索"
        :remote-method="getChannelList"
        :loading="channelLoading"
        style="width: 80%"
        @change="handleChannelChange"
      >
        <el-option
          v-for="item in channelOptions"
          :key="item.id"
          :label="item.realname + '(' + item.alias + ')'"
          :value="item.realname"
        >
        </el-option>
      </el-select>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getChannelList, changeSingleUserChannel } from '@/api/member'

export default {
  name: 'ChangeChannel',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    },
    appId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      channelLoading: false,
      submitting: false,
      channelName: '',
      channelId: '',
      channelOptions: [],
      allChannels: []
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      this.channelName = ''
      this.channelId = ''
      await this.getChannelList()
    },

    // 获取渠道列表
    async getChannelList(query) {
      const params = {}
      if (this.appId) {
        params.app_id = this.appId
      }
      
      try {
        this.channelLoading = true
        const res = await getChannelList(params)
        if (res.err_code === 0) {
          this.allChannels = res.rows || []
          
          if (query) {
            this.channelOptions = (res.rows || []).filter(item => 
              (item.realname + item.alias).toLowerCase().includes(query.toLowerCase())
            )
          } else {
            this.channelOptions = res.rows || []
          }
        }
      } catch (error) {
        console.error('获取渠道列表失败:', error)
      } finally {
        this.channelLoading = false
      }
    },

    // 渠道选择变化
    handleChannelChange(val) {
      // 设置选中的渠道名称
      this.channelName = val
      
      // 重置渠道ID
      this.channelId = ''
      
      if (val) {
        const selectedChannel = this.allChannels.find(channel => channel.realname === val)
        if (selectedChannel) {
          this.channelId = selectedChannel.id
        }
      }
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      if (!this.channelName || !this.channelId) {
        this.$message.warning('请选择渠道')
        return
      }
      
      this.submitting = true
      const params = {
        user_id: Number(this.userId),
        channel_id: Number(this.channelId)
      }
      
      changeSingleUserChannel(params).then(res => {
        if (res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('success')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      }).catch(error => {
        console.error('变更渠道失败:', error)
        this.$message.error('保存失败')
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>